// Shared formatting helpers for the Gain % column used across the pipeline
// pages (Basing/VCP/Watchlist/Readylist) and their row components. Previously
// each page defined its own identical copy of these two functions.

export const formatGainPct = (gainPct) => {
  if (gainPct === null || gainPct === undefined) return '-';
  const sign = gainPct > 0 ? '+' : gainPct < 0 ? '-' : '';
  return `${sign}${Math.abs(gainPct).toFixed(2)}%`;
};

// `prefix` selects which page's CSS classes to use: Basing/VCP ride on
// Leaders.css (`leaders-gain-pos`/`leaders-gain-neg`), while
// Watchlist/Readylist ride on Watchlist.css (`watchlist-gain-pos`/
// `watchlist-gain-neg`). Defaults to 'leaders' since that's the more common
// caller.
export const gainClass = (gain, prefix = 'leaders') => {
  if (gain > 0) return `${prefix}-gain-pos`;
  if (gain < 0) return `${prefix}-gain-neg`;
  return '';
};
